import styles from "./Loader.module.css"
/**
* Props for the Loader component.
*/ 
interface LoaderProps {
    text?: string // Loader text
}
/**
* A loader component with optional text.
*
* @param props Loader props
* @param {string} props.text - Loader text
* @returns TSX.Element
*/
const Loader = ({ text }: LoaderProps) => {
    return (
        <>
            <div className={styles.LoaderWrap}>
                <div className={styles.LoadBox}>
                    {text && <p>{text}</p>}
                    <div className={styles.LoadRow}>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Loader